'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var styled = require('styled-components');
var useIsMobile = require('../../../../../common/providers/useIsMobile.js');
var Loading = require('../../../../../common/components/Loading.js');
var ViewWrapper = require('../../../components/ViewWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const SummaryViewContainer = styled__default["default"].div.withConfig({
  componentId: "sc-8rvaj2-0"
})(["padding-bottom:2rem;"]);
const ClaimSummaryView = _ref => {
  let {
    children,
    onBackClick,
    onDismissClick,
    onNextClick,
    submitClaimStatus
  } = _ref;
  const isMobile = useIsMobile["default"]();
  const {
    claimsSummarySubmitButtonDesktop,
    claimsSummarySubmitButtonMobile,
    claimsSummarySubmittingClaim
  } = nthHookTranslations.useTranslations();
  const showLoading = submitClaimStatus.loading || submitClaimStatus.called && !submitClaimStatus.error;
  return /*#__PURE__*/React__default["default"].createElement(Loading["default"], {
    loading: showLoading,
    text: claimsSummarySubmittingClaim ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapper["default"], {
    dismissButton: {
      onClick: onDismissClick
    },
    backButton: {
      onClick: onBackClick
    },
    bottomButton: {
      children: (isMobile ? claimsSummarySubmitButtonMobile : claimsSummarySubmitButtonDesktop) ?? '',
      onClick: onNextClick
    }
  }, /*#__PURE__*/React__default["default"].createElement(SummaryViewContainer, null, children)));
};
var ClaimSummaryViewContainer = nthHookTranslations.withTranslationsProvider(ClaimSummaryView, {
  translationKeys: ['claimsSummarySubmitButtonDesktop', 'claimsSummarySubmitButtonMobile', 'claimsSummarySubmittingClaim']
});

exports["default"] = ClaimSummaryViewContainer;
